<mat-tab-group
  #tabGroup
  animationDuration="0ms"
  [ngClass]="isStepper ? 'arrow-tabs' : 'switch-tabs'"
  [selectedIndex]="selectedTabIndex"
  (selectedTabChange)="onTabChange($event)"
>
  <mat-tab *ngFor="let tab of tabs" [label]="tab" [disabled]="isTabDisabled(tab)"></mat-tab>
</mat-tab-group>
